import { ISeriesHistoryParams, ISeriesHistoryResponse } from '../../../entity/interface/iChannelSeriesHistory';
import { IChannelSeriesHistoryRepository } from '../../repositories/interfaces/iChannelSeriesHistoryRepository';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
export interface IGetSeriesHistoryUseCase {
    execute(
        apiKey: string,
        profileName: string,
        payload: ISeriesHistoryParams,
        token: string,
        identityToken: string
    ): Promise<ISeriesHistoryResponse>;
}
class GetSeriesHistoryUseCase implements IGetSeriesHistoryUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelSeriesHisRepo(): IChannelSeriesHistoryRepository {
        return container.resolve<IChannelSeriesHistoryRepository>(DI.REPOSITORIES.IChannelSeriesHistoryRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apiKey: string,
        profileName: string,
        payload: ISeriesHistoryParams,
        token: string,
        identityToken: string
    ): Promise<ISeriesHistoryResponse> {
        return await this.channelSeriesHisRepo.getSeriesHistory(apiKey, profileName, payload, token, identityToken);
    }
}

export default GetSeriesHistoryUseCase;
